import type { FunctionComponent, ReactNode } from 'react'
import style from './Quote.module.sass'

type QuoteProps = {
	primary: ReactNode
	secondary?: ReactNode
}

export const Quote: FunctionComponent<QuoteProps> = ({ primary, secondary }) => {
	return (
		<div className={style.root}>
			{secondary ? (
				<blockquote className={style.text}>
					&bdquo;
					{primary}
					&rdquo;
				</blockquote>
			) : (
				<blockquote className={style.text}>{primary}</blockquote>
			)}
			{secondary && <div className={style.author}>{secondary}</div>}
		</div>
	)
}
